async function keRefreshCartDrawer(cart) {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;
  try {
    const r = await fetch('/?sections=cart-drawer');
    if (!r.ok) return;
    const sections = await r.json();
    const html = sections && sections['cart-drawer'];
    if (!html) return;
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-drawer');
    if (!fresh) return;
    drawer.innerHTML = fresh.innerHTML;
    drawer.classList.toggle('is-empty', !cart || cart.item_count === 0);
    // re-bind the overlay close handler lost when innerHTML was replaced
    drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => drawer.close?.());
  } catch (_) {
    // best-effort: the count badge is already updated
  }
}

let keLiveRegion = null;
function keAnnounce(message) {
  if (!keLiveRegion) {
    keLiveRegion = document.createElement('div');
    keLiveRegion.setAttribute('aria-live', 'polite');
    keLiveRegion.setAttribute('role', 'status');
    keLiveRegion.style.cssText =
      'position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0;';
    document.body.appendChild(keLiveRegion);
  }
  keLiveRegion.textContent = '';
  keLiveRegion.textContent = message;
}

let keQuickAddMutationSeq = 0;

document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.ke-qadd');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();
  if (btn.dataset.busy) return;
  btn.dataset.busy = '1';
  const original = btn.textContent;
  const mutationId = `quick-add:${Date.now().toString(36)}:${++keQuickAddMutationSeq}`;
  document.dispatchEvent(new CustomEvent('ke:cart-mutation', {
    detail: { phase: 'start', source: 'quick-add', id: mutationId }
  }));
  try {
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(btn.dataset.variantId), quantity: 1 })
    });
    if (!r.ok) {
      // Shopify answers 422 when the variant can't be added — on this store
      // that's almost always a 1-of-1 pair already in the cart at its stock
      // cap. Show a distinct failure (never the success ✓) and skip the
      // cart-count refresh so the failure isn't masked.
      let msg = 'Could not add';
      if (r.status === 422) {
        msg = 'Already in your bag';
        try {
          const errBody = await r.json();
          if (errBody && errBody.description) msg = errBody.description;
        } catch (_) { /* keep the fallback message */ }
      }
      btn.classList.add('err');
      btn.textContent = r.status === 422 ? 'IN BAG' : '✕';
      keAnnounce(msg);
    } else {
      btn.classList.add('ok');
      btn.textContent = '✓ ' + (btn.dataset.size || original);
      try {
        // the item IS in the cart at this point — badge + drawer refresh are
        // best-effort and must never repaint the button as a failure
        const cart = await (await fetch('/cart.js')).json();
        document.querySelectorAll('.ke-cart-n').forEach((el) => (el.textContent = cart.item_count));
        await keRefreshCartDrawer(cart);
        // open the drawer after a quick add (Tyler 2026-09-11); no-op when it's already open
        const dr = document.querySelector('cart-drawer');
        if (dr && !dr.classList.contains('active') && typeof dr.open === 'function') dr.open(btn);
      } catch (_) {
        // keep the ✓ — the add itself succeeded
      }
      document.dispatchEvent(new CustomEvent('ke:added', { detail: { id: btn.dataset.variantId } }));
      keAnnounce('Added to bag');
    }
  } catch (_) {
    btn.classList.add('err');
    btn.textContent = '✕';
    keAnnounce('Could not add');
  } finally {
    document.dispatchEvent(new CustomEvent('ke:cart-mutation', {
      detail: { phase: 'end', source: 'quick-add', id: mutationId }
    }));
    setTimeout(() => {
      btn.classList.remove('ok', 'err');
      btn.textContent = original;
      delete btn.dataset.busy;
    }, 1800);
  }
});
